
import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import InputBox from '../common/InputBox';
import "./Filter.css";
import SearchSelect from '../common/SearchSelect';
import { getMasterData } from '../../services/enquiryMaster-service';

export default function FilterColumn(props) {
    
    const [errors, setErrors] = useState({});
    const [masterData, setMasterData] = useState([]);

    const getDropDownOptions = (title) => {
        return masterData.filter((Type) => Type.title === title).flatMap((Type) => Type.value.split(','))
            .map((value) => (
                <option key={value} value={value}>
                    {value}
                </option>
            ));
    };

    const fetchData = async () => {
        try {
            const values = await getMasterData();
            setMasterData(values.data.map((item) => ({ title: item.Title, value: item.Value })));
        } catch (error) {
            console.error("error in catch", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const initialFilters = props.headers.filter(header => header.mobileFilter).reduce((value, header) => {
        value[header.columnName] = '';
        return value;
    }, {});

    const [filters, setFilters] = useState(initialFilters);

    useEffect(() => {
        props.setData(props.data);
    }, [props.data, props.setData]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        
        setFilters({
            ...filters,
            [name]: value
        });
        applyFilters({ ...filters, [name]: value });
    };

    const applyFilters = (updatedFilters) => {
        const filtered = props.data.filter(item =>
            props.headers.filter(header => header.mobileFilter).every(header => {
                const val = item[header.columnName];
                const filter = updatedFilters[header.columnName]?.toLowerCase();
                return !filter || (typeof val === 'string' && val.toLowerCase().includes(filter));
            })
        );
        props.setData(filtered);
    };

    
    const resetForm = () => {
        setFilters(initialFilters);
        props.setData(props.data);
    };

    return (
        <div className='filter-column-main'>
            <Button bsPrefix="reset-btn" onClick={resetForm} className="modal-btn-sub">Clear Filter</Button>

            <div className="filter-container">
                {props.headers.filter(header => header.mobileFilter).map(header => (
                    <Form key={header.columnName}>
                        {header.columnName == 'EnquiryStatus' && !props.sessionName == "Pre-Order Timeline" && 
                            (
                                <SearchSelect
                                    name="EnquiryStatus"
                                    value={filters.EnquiryStatus}
                                    option={getDropDownOptions("Enquiry Status")}
                                    label="Enquiry Status"
                                    id="EnquiryStatus"
                                    fieldName="EnquiryStatus"
                                    onChange={handleFilterChange}
                                    placeholder=""
                                    setError={setErrors}
                                />
                            )}
                        {
                            header.columnName == 'Approvalstatus' && (
                                <SearchSelect
                                    name="Approvalstatus"
                                    value={filters.Approvalstatus}
                                    option={getDropDownOptions("DiscountApprovalStatus")}
                                    label="Approval Status"
                                    id="Approvalstatus"
                                    fieldName="EnquiryStatus"
                                    onChange={handleFilterChange}
                                    placeholder=""
                                    setError={setErrors}
                                />
                            )
                        }
                        {header.columnName == 'EnquiryStatus' && props.sessionName == "Pre-Order Timeline" && (
                            <SearchSelect
                                name="EnquiryStatus"
                                value={filters.EnquiryStatus}
                                option={[<option key="Open" value="Open">Open</option>, <option key="Cancelled" value="Cancelled">Cancelled</option>,<option key="Closed" value="Closed">Closed</option>]}
                                label="Pre-Order Status"
                                id="EnquiryStatus"
                                fieldName="EnquiryStatus"
                                onChange={handleFilterChange}
                                placeholder=""
                                setError={setErrors}
                            />
                        )}

                        {header.columnName != 'Approvalstatus' && header.columnName != 'EnquiryStatus' && (
                            <InputBox
                                key={header.columnName}
                                type="text"
                                label={`${header.displayName}`}
                                fieldName={`${header.displayName}`}
                                name={header.columnName}
                                value={filters[header.columnName]}
                                onChange={handleFilterChange}
                                setError={setErrors}
                            />
                        )}
                    </Form>
                ))}
            </div>
        </div>
    );
}
